import React, { Component } from 'react';

class IconOpenedEye extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="22.486" height="13.505" viewBox="0 0 22.486 13.505">
                <g id="Icon_feather-eye" data-name="Icon feather-eye" transform="translate(-0.229 -6.094)">
                    <path id="Path_6400" data-name="Path 6400" d="M1.5,11.752S5.225,6,11.743,6s10.243,5.752,10.243,5.752S18.262,17.5,11.743,17.5,1.5,11.752,1.5,11.752Z" transform="translate(-0.271 1.094)" fill="none" stroke="#4e5b65" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                    <path id="Path_6401" data-name="Path 6401" d="M18.136,15.818A2.318,2.318,0,1,1,15.818,13.5,2.318,2.318,0,0,1,18.136,15.818Z" transform="translate(-4.271 -2.738)" fill="none" stroke="#4e5b65" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                </g>
            </svg>
        );
    }
}

export default IconOpenedEye;